import React from 'react'

const PrivacyContent: React.FC = () => {
  return (
    <div className="flex flex-col gap-24px">
      <div className="text-right">
        <p className="text-style-body2 text-textColorText3">
          시행일: 2026년 1월 1일
        </p>
        <p className="text-style-body2 text-textColorText3">
          최종 수정일: 2026년 6월 7일
        </p>
      </div>

      <div className="bg-brandPrimary-5% p-16px border-l-4px border-brandPrimary rounded-4px">
        <p className="text-style-body1 text-textColorText2 leading-relaxed">
          <strong>tastee</strong>는 「개인정보 보호법」, 「정보통신망 이용촉진
          및 정보보호 등에 관한 법률」 등 관련 법령에 따라 이용자의 개인정보를
          보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과
          같이 개인정보처리방침을 수립·공개합니다.
        </p>
      </div>

      <div>
        <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
          1. 개인정보의 처리목적
        </h2>
        <p className="text-style-body1 text-textColorText2 leading-relaxed mb-12px">
          tastee는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는
          개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이
          변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등
          필요한 조치를 이행할 예정입니다.
        </p>

        <div className="ml-16px">
          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            1.1 서비스 제공
          </h3>
          <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px">
            <li>음식점 리뷰 및 평가 플랫폼 서비스 제공</li>
            <li>회원가입 및 회원제 서비스 이용에 따른 본인확인</li>
            <li>서비스 이용기록과 접속빈도 분석, 서비스 이용에 대한 통계</li>
          </ul>

          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            1.2 회원 관리
          </h3>
          <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px">
            <li>회원 식별, 가입의사 확인, 가입 및 가입횟수 제한</li>
            <li>고충처리, 분쟁조정을 위한 기록 보존</li>
            <li>
              공지사항 전달, 불만처리 등을 위한 원활한 의사소통 경로의 확보
            </li>
          </ul>
        </div>
      </div>

      <div>
        <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
          2. 개인정보의 처리 및 보유기간
        </h2>
        <p className="text-style-body1 text-textColorText2 leading-relaxed mb-12px">
          tastee는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터
          개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를
          처리·보유합니다.
        </p>

        <div className="ml-16px">
          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            2.1 회원 정보
          </h3>
          <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px">
            <li>
              <strong>보유기간:</strong> 회원 탈퇴 시까지
            </li>
            <li>
              <strong>보유근거:</strong> 서비스 이용계약 또는 회원가입 해지
              시까지
            </li>
          </ul>

          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            2.2 서비스 이용기록
          </h3>
          <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px">
            <li>
              <strong>보유기간:</strong> 3년
            </li>
            <li>
              <strong>보유근거:</strong> 정보통신망 이용촉진 및 정보보호 등에
              관한 법률
            </li>
          </ul>
        </div>
      </div>

      <div>
        <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
          3. 처리하는 개인정보의 항목
        </h2>
        <p className="text-style-body1 text-textColorText2 leading-relaxed mb-12px">
          tastee는 다음의 개인정보 항목을 처리하고 있습니다.
        </p>

        <div className="ml-16px">
          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            3.1 필수항목
          </h3>
          <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px">
            <li>이메일 주소</li>
            <li>닉네임</li>
            <li>전화번호</li>
            <li>로그인 유형 (일반, 카카오, 구글, 페이스북, 애플)</li>
          </ul>

          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            3.2 선택항목
          </h3>
          <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px">
            <li>프로필 이미지</li>
          </ul>

          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            3.3 자동 수집 항목
          </h3>
          <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px">
            <li>서비스 이용기록</li>
            <li>접속 IP 정보</li>
            <li>쿠키</li>
            <li>접속 로그</li>
          </ul>

          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            3.4 기기 접근 권한을 통해 기기 내에서만 처리되는 정보
          </h3>
          <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px">
            <li>
              <strong>사진(갤러리) 접근:</strong> 리뷰 사진 첨부 및 방문한 장소
              근처에서 촬영한 사진 추천 기능을 위해 기기의 사진 라이브러리 접근
              권한(선택)을 요청합니다. 사진에 포함된 위치 정보(EXIF GPS)는
              이용자의 기기 내에서만 장소와의 거리 계산에 사용되며, 이용자가
              직접 첨부를 선택한 사진 외에는 회사 서버로 전송·수집·저장되지
              않습니다. 권한을 거부해도 사진 추천 기능 외 서비스 이용에는 제한이
              없습니다.
            </li>
          </ul>
        </div>
      </div>

      <div>
        <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
          4. 개인정보의 제3자 제공
        </h2>
        <p className="text-style-body1 text-textColorText2 leading-relaxed">
          tastee는 정보주체의 개인정보를 제1조(개인정보의 처리목적)에서 명시한
          범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등
          개인정보 보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게
          제공합니다.
        </p>
      </div>

      <div>
        <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
          5. 개인정보처리의 위탁
        </h2>
        <p className="text-style-body1 text-textColorText2 leading-relaxed mb-12px">
          tastee는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보
          처리업무를 위탁하고 있습니다.
        </p>

        <div className="ml-16px">
          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            5.1 위탁받는 자 (수탁자)
          </h3>
          <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px">
            <li>
              <strong>Google LLC</strong>: Firebase 서비스 (인증, 데이터베이스,
              스토리지)
            </li>
            <li>
              <strong>Kakao Corp.</strong>: 카카오 로그인 서비스
            </li>
            <li>
              <strong>Facebook Inc.</strong>: 페이스북 로그인 서비스
            </li>
          </ul>
        </div>
      </div>

      <div>
        <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
          6. 정보주체의 권리·의무 및 행사방법
        </h2>
        <p className="text-style-body1 text-textColorText2 leading-relaxed mb-12px">
          정보주체는 tastee에 대해 언제든지 다음 각 호의 개인정보 보호 관련
          권리를 행사할 수 있습니다.
        </p>
        <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px ml-16px">
          <li>개인정보 처리현황 통지요구</li>
          <li>개인정보 열람요구</li>
          <li>개인정보 정정·삭제요구</li>
          <li>개인정보 처리정지 요구</li>
        </ul>
      </div>

      <div>
        <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
          7. 개인정보의 안전성 확보조치
        </h2>
        <p className="text-style-body1 text-textColorText2 leading-relaxed mb-12px">
          tastee는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고
          있습니다.
        </p>
        <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px ml-16px">
          <li>관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등</li>
          <li>
            기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템
            설치, 개인정보의 암호화, 보안프로그램 설치
          </li>
          <li>물리적 조치: 전산실, 자료보관실 등의 접근통제</li>
        </ul>
      </div>

      <div>
        <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
          8. 개인정보 보호책임자
        </h2>
        <div className="bg-textColorText3-10% p-16px rounded-8px mt-12px">
          <p className="text-style-body1 font-bold text-textColorText2 mb-8px">
            개인정보 보호책임자
          </p>
          <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px mb-16px">
            <li>성명: tastee 개인정보보호책임자</li>
            <li>연락처: privacy@tastee.com</li>
          </ul>

          <p className="text-style-body1 font-bold text-textColorText2 mb-8px">
            개인정보 보호 담당부서
          </p>
          <ul className="list-disc list-inside text-style-body1 text-textColorText2 leading-relaxed space-y-4px">
            <li>부서명: 개인정보보호팀</li>
            <li>연락처: privacy@tastee.com</li>
          </ul>
        </div>
      </div>

      <div>
        <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
          9. 개인정보처리방침의 변경
        </h2>
        <p className="text-style-body1 text-textColorText2 leading-relaxed">
          이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른
          변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일
          전부터 공지사항을 통하여 고지할 것입니다.
        </p>
      </div>

      <div>
        <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
          10. 개인정보의 안전성 확보를 위한 기술적/관리적 대책
        </h2>

        <div className="ml-16px">
          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            10.1 개인정보 암호화
          </h3>
          <p className="text-style-body1 text-textColorText2 leading-relaxed mb-12px">
            이용자의 개인정보는 비밀번호에 의해 보호되며, 파일 및 전송 데이터를
            암호화하거나 파일 잠금 기능을 사용하여 중요한 데이터는 별도의
            보안기능을 통해 보호되고 있습니다.
          </p>

          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            10.2 해킹 등에 대비한 기술적 대책
          </h3>
          <p className="text-style-body1 text-textColorText2 leading-relaxed mb-12px">
            tastee는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을
            막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며
            외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로
            감시 및 차단하고 있습니다.
          </p>

          <h3 className="text-style-body1 font-bold text-textColorText2 mb-8px mt-16px">
            10.3 개인정보에 대한 접근 제한
          </h3>
          <p className="text-style-body1 text-textColorText2 leading-relaxed">
            개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경,
            말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고
            있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고
            있습니다.
          </p>
        </div>
      </div>

      <div className="bg-brandPrimary-5% p-16px border-l-4px border-brandPrimary rounded-4px mt-24px">
        <p className="text-style-body1 font-bold text-textColorText2">
          본 개인정보처리방침은 2026년 1월 1일부터 시행됩니다.
        </p>
      </div>
    </div>
  )
}

export default PrivacyContent
